import {Box, FormControlLabel, Switch} from '@mui/material';
import React, {useEffect} from "react";
import {Controller, useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import {editViewer} from "../../actions/viewer";
import Button from "../../common/button/button";
import InputFieldWithLabel from "../../common/input/inputFieldWithLabel";
import Style from "../../common/input/inputFieldWithLabel.module.css";
import {newModalStyle, submitButtonStyle} from "../../reusable/styles";

const ModalEditViewer = (props) => {
  const { handleSubmit, register, unregister, reset, control } = useForm({
    defaultValues: {
      ...props.selectedViewer,
      emailReporting: false // Start with a clean false
    },
  });
  
  useEffect(() => {
    const emailReportingValue = props.selectedViewer?.emailReporting;
    let booleanValue = false;
    
    if (emailReportingValue === "true" || emailReportingValue === true) {
      booleanValue = true;
    }
    
    console.log('Setting emailReporting to:', booleanValue, 'from:', emailReportingValue);
    
    reset({
      ...props.selectedViewer,
      emailReporting: booleanValue
    });
  }, [props.selectedViewer, reset]);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const updateViewer = (data) => {
    const dataForEdit = {
      id: data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      phoneNumber: data.phoneNumber,
      companyName: data.companyName,
      emailReporting: data.emailReporting === true ? "true" : "false"
    };

    dispatch(editViewer(dataForEdit));
    props.close();
  };

  useEffect(() => {
    reset(props.selectedViewer);
  }, [props.selectedViewer, reset]);

  const closeModal = () => {
    props.close();
    unregister("firstName");
  };

  return (
    <Modal
      open={props.open}
      closeOnEs={true}
      onClose={closeModal}
      center
      styles={newModalStyle({ width: "450px" })}
    >
      <div className="modal__headerLine" />
      <div className="modal__title">{t("ModalAddViewer.title")}</div>
      <form className="modalForm" onSubmit={handleSubmit(updateViewer)}>
        <div className="form">
          <InputFieldWithLabel
            label={t("ModalAddViewerForm.firstName")}
            name="firstName"
            required
            registerName="firstName"
            register={register}
          />
          <InputFieldWithLabel
            label={t("ModalAddViewerForm.lastName")}
            name="lastName"
            registerName="lastName"
            required
            register={register}
          />

          <InputFieldWithLabel
            label="E-mail"
            name="emailAddress"
            disabled
            type="email"
            registerName="emailAddress"
            required
            register={register}
          />
          <InputFieldWithLabel
            label={t("ModalAddViewerForm.phoneNumber")}
            name="phoneNumber"
            registerName="phoneNumber"
            register={register}
          />
          <InputFieldWithLabel
            label={t("ModalAddViewerForm.companyName")}
            name="companyName"
            registerName="companyName"
            register={register}
          />
          <Box sx={{ mb: 2 }}>
            <div className={Style.input__label}>
              {t("ModalAddViewerForm.emailReporting")}
              <hr className={Style.input__hr} />
            </div>
            <Controller
              name="emailReporting"
              control={control}
              render={({ field: { onChange, value } }) => {
                // Convert string to boolean explicitly
                const booleanValue = value === true || value === "true";
                console.log('Toggle value:', value, 'Type:', typeof value, 'Boolean:', booleanValue);

                return (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={booleanValue}
                        onChange={(e) => {
                          console.log('Switch changed to:', e.target.checked);
                          onChange(e.target.checked);
                        }}
                        size="small"
                      />
                    }
                    label={booleanValue ? t("Enabled") : t("Disabled")}
                    labelPlacement="end"
                  />
                );
              }}
            />
          </Box>
        </div>
        <Button text="Speichern" buttonStyle={submitButtonStyle} />
      </form>
    </Modal>
  );
};
export default ModalEditViewer;
